var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [
        _vm._v(
          _vm._s(_vm.$t("booking.booking")) +
            " " +
            _vm._s(_vm.booking.reservation_number)
        )
      ]),
      _c(
        "v-row",
        { staticClass: "flight-header" },
        [
          _c(
            "v-col",
            {
              staticClass: "header-flight-part-block flight-part white",
              attrs: { cols: "4" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "inline-flex" } },
                [
                  _c("v-icon", { staticClass: "header-flight-icon" }, [
                    _vm._v("flight_takeoff")
                  ])
                ],
                1
              ),
              _c("div", { staticStyle: { display: "inline-block" } }, [
                _c("div", { staticClass: "flight-direction grey--text" }, [
                  _vm._v(" " + _vm._s(_vm.$t("booking.flight.departure")) + " ")
                ]),
                _c("div", { staticClass: "flight-airport" }, [
                  _c(
                    "span",
                    {
                      staticClass: "bigger",
                      staticStyle: { "font-weight": "bold" }
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", color: "white" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "span",
                                    _vm._g({ staticClass: "accent--text" }, on),
                                    [
                                      _vm._v(
                                        _vm._s(_vm.booking.start_airport_code)
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("span", { staticStyle: { color: "#0f0f0f" } }, [
                            _vm._v(_vm._s(_vm.booking.start_airport_name) + " ")
                          ])
                        ]
                      ),
                      _c("span", { staticClass: "arrow" }, [_vm._v("➞")]),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", color: "white" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "span",
                                    _vm._g({ staticClass: "accent--text" }, on),
                                    [
                                      _vm._v(
                                        _vm._s(_vm.booking.end_airport_code) +
                                          " "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c("span", { staticStyle: { color: "#0f0f0f" } }, [
                            _vm._v(_vm._s(_vm.booking.end_airport_name))
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.booking.start_time != null
                          ? _vm.booking.start_time.substr(0, 5)
                          : _vm.$t("global.noData")
                      ) +
                      " - " +
                      _vm._s(
                        _vm.booking.end_time != null
                          ? _vm.booking.end_time.substr(0, 5)
                          : _vm.$t("global.noData")
                      ) +
                      " "
                  )
                ]),
                _c("div", { staticClass: "flight-date grey--text" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.booking.start_date != null
                          ? _vm.dayOfWeek(_vm.booking.start_date)
                          : _vm.$t("global.noData")
                      ) +
                      " " +
                      _vm._s(
                        _vm.booking.start_date != null
                          ? _vm.formatDateView(_vm.booking.start_date)
                          : _vm.$t("global.noData")
                      ) +
                      " "
                  )
                ])
              ])
            ]
          ),
          _vm.booking.return_start_airport_code != null
            ? _c(
                "v-col",
                {
                  staticClass: "header-flight-part-block flight-part white ",
                  attrs: { cols: "4" }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "inline-flex" } },
                    [
                      _c("v-icon", { staticClass: "header-flight-icon" }, [
                        _vm._v("flight_land")
                      ])
                    ],
                    1
                  ),
                  _c("div", { staticStyle: { display: "inline-block" } }, [
                    _c("div", { staticClass: "flight-direction grey--text" }, [
                      _vm._v(" " + _vm._s(_vm.$t("booking.returnRoute")) + " ")
                    ]),
                    _c("div", { staticClass: "flight-airport" }, [
                      _c(
                        "span",
                        {
                          staticClass: "bigger",
                          staticStyle: { "font-weight": "bold" }
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", color: "white" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            { staticClass: "accent--text" },
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.booking
                                                  .return_start_airport_code
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1087721868
                              )
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#0f0f0f" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.booking.return_start_airport_name
                                    )
                                  )
                                ]
                              )
                            ]
                          ),
                          _c("span", { staticClass: "arrow" }, [_vm._v("➞")]),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", color: "white" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            { staticClass: "accent--text" },
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.booking
                                                  .return_end_airport_code
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2508857251
                              )
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#0f0f0f" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.booking.return_end_airport_name)
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.booking.return_start_time != null
                              ? _vm.booking.return_start_time.substr(0, 5)
                              : _vm.$t("global.noData")
                          ) +
                          " - " +
                          _vm._s(
                            _vm.booking.return_end_time != null
                              ? _vm.booking.return_end_time.substr(0, 5)
                              : _vm.$t("global.noData")
                          ) +
                          " "
                      )
                    ]),
                    _c("div", { staticClass: "flight-date grey--text" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.booking.return_start_date != null
                              ? _vm.dayOfWeek(_vm.booking.return_start_date)
                              : _vm.$t("global.noData")
                          ) +
                          " " +
                          _vm._s(
                            _vm.booking.return_start_date != null
                              ? _vm.formatDateView(
                                  _vm.booking.return_start_date
                                )
                              : _vm.$t("global.noData")
                          ) +
                          " "
                      )
                    ])
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c("h2", [_vm._v(_vm._s(_vm.$t("booking.bookingDetails")))]),
      _c(
        "div",
        { staticClass: "grey--text pa-2" },
        [
          _c("v-icon", { staticClass: "mr-1" }, [
            _vm._v("airplanemode_active")
          ]),
          _vm._v(" " + _vm._s(_vm.booking.airline_name) + " ")
        ],
        1
      ),
      _c("v-divider", { staticStyle: { "margin-bottom": "15px" } }),
      _c(
        "v-expansion-panels",
        { attrs: { flat: "", accordion: "" } },
        [
          _c(
            "v-expansion-panel",
            { staticClass: "pa-0 upper-line" },
            [
              _c(
                "v-expansion-panel-header",
                {},
                [
                  _c("booking-flight-part-detail", {
                    attrs: {
                      end_airport_code: _vm.booking.end_airport_code,
                      end_airport_name: _vm.booking.end_airport_name,
                      end_date: _vm.booking.end_date,
                      end_time: _vm.booking.end_time,
                      label: _vm.$t("booking.flight.departure"),
                      start_airport_code: _vm.booking.start_airport_code,
                      start_airport_name: _vm.booking.start_airport_name,
                      start_date: _vm.booking.start_date,
                      start_time: _vm.booking.start_time,
                      transfers: _vm.travelTransfersFirstPart
                    }
                  })
                ],
                1
              ),
              _c(
                "v-expansion-panel-content",
                [
                  _c("booking-flight-route-collapse", {
                    attrs: {
                      routes: _vm.booking.routes.filter(function(route) {
                        return route.is_return_route == 0
                      })
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.booking.return_start_date != null
            ? [
                _c(
                  "v-expansion-panel",
                  { staticClass: "pa-0 upper-line mt-8" },
                  [
                    _c(
                      "v-expansion-panel-header",
                      [
                        _c("booking-flight-part-detail", {
                          attrs: {
                            end_airport_code:
                              _vm.booking.return_end_airport_code,
                            end_airport_name:
                              _vm.booking.return_end_airport_name,
                            end_date: _vm.booking.return_end_date,
                            end_time: _vm.booking.return_end_time,
                            label: _vm.$t("booking.returnRoute"),
                            start_airport_code:
                              _vm.booking.return_start_airport_code,
                            start_airport_name:
                              _vm.booking.return_start_airport_name,
                            start_date: _vm.booking.return_start_date,
                            start_time: _vm.booking.return_start_time,
                            transfers: _vm.travelTransfersSecondPart
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-expansion-panel-content",
                      [
                        _c("booking-flight-route-collapse", {
                          attrs: {
                            routes: _vm.booking.routes.filter(function(route) {
                              return route.is_return_route == 1
                            })
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _c("h2", { staticClass: "mt-3" }, [
        _vm._v(_vm._s(_vm.$t("booking.passengers")))
      ]),
      _vm._l(_vm.booking.passengers, function(passenger) {
        return _c("div", [
          _c(
            "fieldset",
            { staticClass: "pd-1 custom-fieldset" },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "text-center align-content-center fill-height align-content-center",
                      attrs: { md: "1", cols: "1" }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            "font-size": "46px",
                            color: "rgba(0, 0, 0, 0.32)"
                          }
                        },
                        [_vm._v("fa-user-circle")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "5" } },
                    [
                      _c("v-text-field", {
                        staticClass: "no-line-after-input",
                        staticStyle: { "text-transform": "capitalize" },
                        attrs: {
                          label: _vm.$t("booking.passenger"),
                          value: passenger,
                          disabled: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      }),
      _vm.$store.getters.hasPermission("viewInvoices")
        ? [
            _c("h2", [_vm._v(_vm._s(_vm.$t("global.invoice")))]),
            _vm.booking.invoices.length === 0
              ? _c("span", [
                  _vm._v(" " + _vm._s(_vm.$t("booking.invoiceNotSet")) + " ")
                ])
              : _vm._l(_vm.booking.invoices, function(invoice) {
                  return _c(
                    "span",
                    { key: invoice.id },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass:
                                "text-center align-content-center fill-height align-content-center",
                              attrs: { md: "1", cols: "1" }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: {
                                    "font-size": "46px",
                                    color: "rgba(0, 0, 0, 0.32)"
                                  }
                                },
                                [_vm._v("mdi-file-document")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { md: "3", cols: "5" } },
                            [
                              _c("v-text-field", {
                                staticClass: "no-line-after-input",
                                attrs: {
                                  label: _vm.$t(
                                    "invoice.details.invoiceNumber"
                                  ),
                                  value: invoice.number,
                                  disabled: ""
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            _vm._l(invoice.items, function(invoiceItem) {
                              return _c(
                                "v-row",
                                { key: invoiceItem.id },
                                [
                                  _c("v-text-field", {
                                    staticClass: "no-line-after-input",
                                    attrs: {
                                      label: _vm.$t(
                                        "booking.other.serviceName"
                                      ),
                                      disabled: "",
                                      value:
                                        invoiceItem.name +
                                        " " +
                                        invoiceItem.gross_in_currency +
                                        " " +
                                        invoiceItem.currency
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            { staticClass: "text-right", attrs: { cols: "1" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    to: "/invoices/details/" + invoice.id,
                                    icon: ""
                                  }
                                },
                                [_c("v-icon", [_vm._v("remove_red_eye")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }